import { io, type Socket } from "socket.io-client";

import { REALTIME_BASE_URL } from "@/config/api";

export interface RealtimeInvalidationPayload {
  topics: string[];
  timestamp: string;
}

interface AppRealtimeOptions {
  accessToken?: string | null;
  requiresAuth?: boolean;
}

export async function connectAppRealtime(options: AppRealtimeOptions = {}): Promise<Socket | null> {
  if (!REALTIME_BASE_URL) {
    return null;
  }

  const token = options.accessToken?.trim() ?? null;

  if (options.requiresAuth && !token) {
    return null;
  }

  return io(REALTIME_BASE_URL, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    auth: token ? { token } : undefined
  });
}
